import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
var _excluded = ["text"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState } from 'react';
import classnames from 'classnames';
import { Button } from "../Button/Button/Button";
import { Link } from "../Button/Link/Link";
import { RecommendedFlag } from "../Flag/RecommendedFlag/RecommendedFlag";
import { ScrollTracking } from "../ScrollTracking/ScrollTracking";
import { Text } from "../Text/Text/Text";
import { Theme } from "../Background/Theme/Theme";
import { MatchHeightElement } from "../Utility/MatchHeight/MatchHeightElement";
import styles from "./Tab.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Tab = function Tab(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$url = _ref.url,
    url = _ref$url === void 0 ? '' : _ref$url,
    _ref$subtitle = _ref.subtitle,
    subtitle = _ref$subtitle === void 0 ? '' : _ref$subtitle,
    _ref$active = _ref.active,
    active = _ref$active === void 0 ? false : _ref$active,
    _ref$activeBar = _ref.activeBar,
    activeBar = _ref$activeBar === void 0 ? false : _ref$activeBar,
    _ref$button = _ref.button,
    button = _ref$button === void 0 ? {} : _ref$button,
    _ref$flag = _ref.flag,
    flag = _ref$flag === void 0 ? '' : _ref$flag,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'darkBackground' : _ref$theme,
    position = _ref.position;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    pricingBarVisibility = _useState2[0],
    setPricingBarVisibility = _useState2[1];
  var renderButton = function renderButton(button, active) {
    var text = button.text,
      other = _objectWithoutProperties(button, _excluded);
    return button.url && button.text && /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
      dynamicSize: true,
      tabIndex: active ? 0 : -1
    }, other), {}, {
      children: text
    }));
  };
  var renderPricingBar = function renderPricingBar(title, subtitle, active, button) {
    return /*#__PURE__*/_jsx(Theme, {
      theme: "lightBackground",
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.priceBarWrapper,
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.priceBarInfo,
          children: [/*#__PURE__*/_jsx("div", {
            className: styles.priceBarTitle,
            children: title
          }), /*#__PURE__*/_jsx("div", {
            className: styles.priceBarPricing,
            children: /*#__PURE__*/_jsx(Text, {
              className: styles.priceBarPrice,
              childrenInline: true,
              typog: "bodycopyLarge",
              children: subtitle
            })
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: styles.priceBarButton,
          children: renderButton(button, active)
        })]
      })
    });
  };
  return /*#__PURE__*/_jsx(Theme, {
    theme: active ? 'lightBackground' : theme,
    children: /*#__PURE__*/_jsxs("div", {
      className: classnames({
        [styles.wrapper]: true,
        [styles[position ? position : '']]: !!position,
        [styles.active]: active
      }),
      children: [/*#__PURE__*/_jsx(ScrollTracking, {
        onHide: function onHide() {
          return setPricingBarVisibility(true);
        },
        onShow: function onShow() {
          return setPricingBarVisibility(false);
        },
        children: /*#__PURE__*/_jsx("div", {
          className: styles.link,
          children: /*#__PURE__*/_jsxs(Link, {
            url: url,
            role: "tab",
            "aria-selected": active,
            tabIndex: 0,
            id: title,
            "aria-controls": title,
            children: [flag && /*#__PURE__*/_jsx(RecommendedFlag, {
              text: flag
            }), /*#__PURE__*/_jsx("div", {
              className: styles.content,
              children: /*#__PURE__*/_jsxs(MatchHeightElement, {
                group: "title-subtitle",
                children: [/*#__PURE__*/_jsx(Text, {
                  typog: "headline6",
                  className: styles.title,
                  children: title
                }), /*#__PURE__*/_jsx(Text, {
                  typog: "bodycopySmall",
                  className: styles.price,
                  children: subtitle
                })]
              })
            })]
          })
        })
      }), activeBar && pricingBarVisibility && /*#__PURE__*/_jsx("div", {
        className: styles.priceBar,
        children: renderPricingBar(title, subtitle, active, button)
      })]
    })
  });
};